import { queryOptions, useQuery } from '@tanstack/react-query';

import { RightsizingRecommendation } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

const RIGHTSIZING_SUMMARY_QUERY_KEY = 'rightsizing-summary';

const getRightsizingSummaryQueryKey = (clusterId: string) =>
  [RIGHTSIZING_SUMMARY_QUERY_KEY, clusterId] as const;

const getRightsizingSummaryQueryOptions = ({
  clusterId,
  enabled = true,
}: {
  clusterId: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getRightsizingSummaryQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.costReport.getRightsizingSummary({
        clusterId,
      });
      return data?.rightsizingRecommendation ?? undefined;
    },
    enabled: !!clusterId && enabled,
  });

type RightsizingSummaryQuery = {
  isLoading: boolean;
  data?: RightsizingRecommendation;
  error: unknown;
  refetch: () => void;
};

type UseRightsizingSummaryQuery = {
  clusterId: string;
  enabled?: boolean;
};

export const useRightsizingSummaryQuery = ({
  clusterId,
  enabled = true,
}: UseRightsizingSummaryQuery): RightsizingSummaryQuery => {
  const { isLoading, data, error, refetch } = useQuery(
    getRightsizingSummaryQueryOptions({ clusterId, enabled })
  );

  return {
    isLoading,
    data: data ?? undefined,
    error,
    refetch,
  };
};
